// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ExperimentOutlined from '@ant-design/icons/ExperimentOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';

// icons
const icons = { ExperimentOutlined, PriceChangeOutlinedIcon };

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const labs = {
  id: 'labs/lab-test-list',
  title: <FormattedMessage id="Procedures" />,
  icon: icons.ExperimentOutlined,
  type: 'group',
  visible: (roles, isAdmin) => isAdmin || roles.includes('doctor') || roles.includes('senior_lab_technician'),
  children: [
    {
      id: 'lab-test-list',
      key:'lab-test-list',
      title: <FormattedMessage id="Procedure Pricing" />,
      type: 'item',
      url: '/labs/lab-test-list',
      icon: icons.PriceChangeOutlinedIcon,
      visible: (roles, isAdmin) => isAdmin || roles.includes('doctor') || roles.includes('senior_lab_technician')
    }
  ]
};

export default labs;
